export const REDIRECT_DELAY = 5000;
